import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, logout } from "../../firebase/firebase";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import { ConnectButton } from "@rainbow-me/rainbowkit";

function Navbar() {
  const [userisLogged, setUserisLogged] = useState();

  const navigate = useNavigate();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);

  const logOut = () => {
    logout();
  };
  return (
    <div>
      <nav className="navbar navbar-expand-lg ">
        <Link className="navbar-brand" to="/">
          <img src="\assets\images\navbar-icons\siteLogo.svg" alt="sitelogo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink className="nav-link " aria-current="page" to="/">
                <img src="\assets\images\navbar-icons\home.svg" alt="" />
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/map">
                <img src="\assets\images\navbar-icons\map.svg" alt="" />
                Map
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/marketplace">
                <img src="\assets\images\navbar-icons\marketplace.svg" alt="" />
                Marketplace
              </NavLink>
            </li>

            {userisLogged ? (
              <li className="nav-item">
                <Link className="nav-link" to="/account">
                  <img src="\assets\images\navbar-icons\profile.svg" alt="" />
                  Profile
                </Link>
              </li>
            ) : (
              <></>
            )}

            <li className="nav-item">
              <a className="nav-link" href="#">
                <img src="\assets\images\navbar-icons\about.svg" alt="" />
                About
              </a>
            </li>
          </ul>


          {/* dropdown */}

          <div class="dropdown">
            <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <Icon icon="material-symbols:language" color="white" width="28" height="28" />
            <Icon icon="octicon:chevron-down-24" color="white" width="30" height="30" />
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a className="dropdown-item" href="#">English</a>
              <a className="dropdown-item" href="#">Porteguese</a>
              <a className="dropdown-item" href="#">French</a>
              <a className="dropdown-item" href="#">Chinese</a>
              <a className="dropdown-item" href="#">Hindi</a>
            </div>
          </div>

          {userisLogged ? (
            <></>
          ) : (
            <div className="navbar-btn">
              <div
                className="sign-btn cursor-pointer"
                onClick={() => navigate("/login")}
              >
                <button>Sign In</button>
              </div>
              {/* <div
                className="create-account-btn cursor-pointer"
                onClick={() => navigate("/sign-up")}
              >
                <button>Create Account</button>
              </div> */}
            </div>
          )}

          {userisLogged ? (
            <Dropdown className="d-inline mx-2">
              <Dropdown.Toggle id="dropdown-autoclose-true">
                <div className="profile-image">
                  {userisLogged.displayName ? (
                    <p>{userisLogged.displayName}</p>
                  ) : (
                    <p>Jhon Doe</p>
                  )}
                  <Icon width="30px" height="30px" icon="ei:chevron-down" />
                  {userisLogged.photoURL ? (
                    <div className="profile-ok">
                      <img src={userisLogged.photoURL} alt="" />
                    </div>
                  ) : (
                    <div className="profile-image-wrapper">
                      <Icon
                        width="25px"
                        height="25px"
                        icon="basil:user-solid"
                      />
                    </div>
                  )}
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div
                  className="dropdown-itemsss cursor-pointer"
                  onClick={logOut}
                >
                  {" "}
                  <Icon
                    width="20px"
                    height="20px"
                    icon="tabler:logout-2"
                  />{" "}
                  Logout
                </div>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <></>
          )}
          <ConnectButton.Custom>
            {({
              account,
              chain,
              openAccountModal,
              openChainModal,
              openConnectModal,
              authenticationStatus,
              mounted,
            }) => {
              // Note: If your app doesn't use authentication, you
              // can remove all 'authenticationStatus' checks
              const ready = mounted && authenticationStatus !== "loading";
              const connected =
                ready &&
                account &&
                chain &&
                (!authenticationStatus ||
                  authenticationStatus === "authenticated");

              return (
                <div
                  {...(!ready && {
                    "aria-hidden": true,
                    style: {
                      opacity: 0,
                      pointerEvents: "none",
                      userSelect: "none",
                    },
                  })}
                  className="rainbow-kit-wrapper"
                >
                  {(() => {
                    if (!connected) {
                      return (
                        <button onClick={openConnectModal} type="button">
                          Connect Wallet
                        </button>
                      );
                    }

                    if (chain.unsupported) {
                      return (
                        <button onClick={openChainModal} type="button">
                          Wrong network
                        </button>
                      );
                    }

                    return (
                      <div style={{ display: "flex", gap: 12 }}>
                        {/* <button
                          onClick={openChainModal}
                          style={{ display: 'flex', alignItems: 'center' }}
                          type="button"
                        >
                          {chain.hasIcon && (
                            <div
                              style={{
                                background: chain.iconBackground,
                                width: 12,
                                height: 12,
                                borderRadius: 999,
                                overflow: 'hidden',
                                marginRight: 4,
                              }}
                            >
                              {chain.iconUrl && (
                                <img
                                  alt={chain.name ?? 'Chain icon'}
                                  src={chain.iconUrl}
                                  style={{ width: 12, height: 12 }}
                                />
                              )}
                            </div>
                          )}
                          {chain.name}
                        </button> */}

                        <button onClick={openAccountModal} type="button">
                          {account.displayName}
                        </button>
                      </div>
                    );
                  })()}
                </div>
              );
            }}
          </ConnectButton.Custom>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
